import { useState } from "react";
import "./Contact.css";
import { Mail, Phone, MapPin } from "lucide-react";


function Contact() {
  
  //state
const [form, setForm] = useState({
    name: "",
    email: "",
    message: ""
  });

  //handle input
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  //Submit
 
  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await fetch("http://localhost:5000/send-email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });

     if (res.ok) {
      alert("Email sent successfully!");
      setForm({ name: "", email: "", message: "" });
    } else {
      alert("Error sending email");
    }
  };

  return (
    <section className="contact">

      {/* Heading */}
      <p className="contact-small">Connect</p>
      <h2 className="contact-title">Get in touch</h2>
      <p className="contact-subtitle">
        We're here to answer your questions
      </p>

      {/* Cards */}
      <div className="contact-cards">
        <div className="card">
          <Mail className="icon" />
          <h3>Email</h3>
          <p>Send us a message</p>
          <a href="mailto:info@dharafoundation.com" >
            info@dharafoundation.com
          </a>
        </div>

        <div className="card">
          <Phone className="icon" />
          <h3>Phone</h3>
          <p>Call us during business hours</p>
          <a href="tel:+919022065517">+91 9022065517</a>
          <a href="tel:+918378980211">+91 83789 80211</a>
        </div>

        <div className="card">
          <MapPin className="icon" />
          <h3>Office</h3>
          <p>
            <strong>धRa Foundation,</strong> Ambrosia Galaxy, Office No. 508, 5 floor, 33/1, Pan Card Club Road, Baner High St, Hill Road, Baner, Pune Maharashtra 411045
          </p>
        </div>
      </div>

      {/* Map */}
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps?q=Ambrosia+Galaxy+Baner+Pune&output=embed"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title="Google Map"
        ></iframe>
      </div>

    </section>
  );
}

export default Contact;